import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import {
  AuthService,
  ICommunityService,
  ICorporationModelService,
} from '@tokens/injection.tokens';
import { Injectable, inject } from '@angular/core';
import { Observable, of, switchMap, tap } from 'rxjs';
import { map, uniq } from 'lodash';
import { AuthenticationService } from '@services/account/authentication.service';
import { CommonVerbsApiService } from '@services/common/common-verbs-api.service';
import { Community } from '@models/communities/community.model';
import { catchError } from 'rxjs/operators';

@Injectable()
export class CommunityGuard implements CanActivate {
  community$ = inject(ICommunityService);
  corporation$ = inject(ICorporationModelService);
  service = inject(AuthService);
  auth = inject(AuthenticationService);

  api = inject(CommonVerbsApiService);
  router = inject(Router);
  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const id = route.params.id;
    return this.api
      .get<Community>(`communities/${id}`, null, [
        'careTypes',
        'forms',
        'locations',
        'clubs',
      ])
      .pipe(
        switchMap(community => {
          if (community) {
            let roleNames = uniq(
              map(this.service.model?.roles, r => `${r.name}`.toLowerCase())
            );
            if (!roleNames.includes('admin')) {
              const roles =
                this.service.model?.roles.filter(
                  x =>
                    x.communityId === community.id ||
                    x.corporationId === community.corporation.id
                ) ?? [];
              if (!roles.length) {
                this.auth.logout();
                return of(false);
              }
              roleNames = uniq(map(roles, r => `${r.name}`.toLowerCase()));
              if (!roleNames.includes('corporation_admin')) {
                if (!roleNames.includes('corporation_restricted')) {
                  if (!roleNames.includes('community_admin')) {
                    if (!roleNames.includes('community_caregiver')) {
                      this.auth.logout();
                      return of(false);
                    }
                  }
                }
              }
            }
            //
            this.community$.set(community);
            this.corporation$.set(null);
            return of(true);
          }
          return this.notfound();
        }),
        catchError(() => this.notfound())
      );
  }

  private notfound() {
    this.router.navigate(['/404']).then();
    return of(false);
  }
}
